export default __webpack_public_path__ + "static/media/add_post.f86d1592.svg";